import React, { useState } from 'react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { deviceMgmtSteps } from '../data';
import type { PlatformSubpageConfig } from '../types';

export const DeviceMgmtContent: React.FC<{ config: PlatformSubpageConfig }> = ({ config }) => {
  const [active, setActive] = useState(0);
  const step = deviceMgmtSteps[active];

  return (
    <SiteSection className="platform-sub-interactive">
      <SiteSectionHeader
        eyebrow="INTERACTIVE"
        title={config.sections.title}
        subtitle={config.sections.subtitle}
        align="center"
      />
      <ol className="platform-sub-steps">
        {deviceMgmtSteps.map((s, i) => (
          <li key={s.id}>
            <button
              type="button"
              className={`platform-sub-steps__btn${active === i ? ' platform-sub-steps__btn--active' : ''}`}
              aria-current={active === i ? 'step' : undefined}
              onClick={() => setActive(i)}
            >
              <span className="platform-sub-steps__num">{i + 1}</span>
              <span className="platform-sub-steps__label">{s.title}</span>
            </button>
          </li>
        ))}
      </ol>
      <div className="platform-sub-step-detail">
        <h3 className="platform-sub-step-detail__title">{step.title}</h3>
        <p className="platform-sub-step-detail__desc">{step.description}</p>
        <p className="platform-sub-step-detail__extra">{step.detail}</p>
      </div>
    </SiteSection>
  );
};
